import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=5e4dbb67"
import script from "./TermsModal.vue?vue&type=script&lang=ts"
export * from "./TermsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports